//initial redux
import { put, call, takeEvery, fork, all, take, select, takeLatest } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";
import { seriesColor, unitsservice, pointName, DateTime, array, number, tooltip } from "../../../../utils";
import Highcharts from "highcharts";

const initialState = {};

/////////
//types
export const types = {
	MOUSE_MOVED_IN_CONTAINER: "components/chartTooltip/MOUSE_MOVED_IN_CONTAINER",
	UNMOUNT: "components/chartTooltip/UNMOUNT",
	ADD_SERIES: "components/chartTooltip/ADD_SERIES",
	SET_MOVE_DATA: "components/chartTooltip/SET_MOVE_DATA",
	CHART_MOUSE_MOVE: "components/chartTooltip/CHART_MOUSE_MOVE",
	SET_TOOLTIP_DATA: "components/chartTooltip/SET_TOOLTIP_DATA",
	SET_MOUSE_IN: "components/chartTooltip/SET_MOUSE_IN",
	REMOVE: "components/chartTooltip/REMOVE",
	OVERRIDE: "components/chartTooltip/OVERRIDE",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.SET_MOVE_DATA: {
				return { ...state, moveData: action.payload };
			}
			case types.SET_TOOLTIP_DATA: {
				return { ...state, tooltipData: action.payload };
			}
			case types.SET_MOUSE_IN: {
				return { ...state, isMouseIn: action.payload };
			}
			case types.OVERRIDE: {
				return { ...state, isMouseIn: false };
			}
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.onMouseMovedInContainer(),
			this.onAddSeries(),
			this.onRemove(),
		]);
	},

	*onRemove() {
		yield takeEvery(types.REMOVE, function*({payload}) {
			let moveData = yield select(x => x.charttooltip.moveData);
			
			moveData = moveData || {};
			moveData[payload] = undefined;

			yield put(actions.setMoveData(moveData));
		});
	},

	*onAddSeries() {
		yield takeEvery(types.ADD_SERIES, function*({payload}) {
			let moveData = yield select(x => x.charttooltip.moveData);

			const {id, series} = payload;

			if(!moveData) {
				moveData = [];
			}


			if(!moveData[id]) {
				moveData[id] = [];
			}

			for(var ii = 0; ii < moveData[id].length; ii++) {
				if(moveData[id][ii].name === series.name) {
					moveData[id].splice(ii, 1);
					break;
				}
			}
			
			moveData[id].push(series);

			yield put(actions.setMoveData(moveData));
		});
	},

	*onMouseMovedInContainer() {
		yield takeLatest(types.MOUSE_MOVED_IN_CONTAINER, function*({payload}) {

			yield delay(10);

			const { e, id, x, isIn, now } = payload;

			const data = yield select(x => x.charttooltip.moveData);
			if(!data || !data[id]) {
				return;
			}
			const series = data[id];

			let tooltipData = {
				time: null,
				data: [],
			};

			// const mouseLowerX = x - 36000000;
			// const mouseUpperX = x + 36000000;

			let highchartDiv = document.getElementById(id);

			if(isIn) {
				tooltipData.time = x;
				tooltipData.data = [];
				for(var ii = 0; ii < series.length; ii++) {
					let nearest = null;
					if(series[ii] && series[ii].data && series[ii].data.length) {
						if(series[ii].name === "Comments") {
							nearest = tooltip.binarySearch(series[ii].data, x, 0, series[ii].data.length - 1);
						} else {
							nearest = tooltip.binarySearchLeft(series[ii].data, x, 0, series[ii].data.length - 1);
						}
					}
					if(!series[ii].color && highchartDiv) {
						var chart = Highcharts.charts[highchartDiv.childNodes[0].getAttribute('data-highcharts-chart')];
						for(var jj = 0; jj < chart.series.length; jj++) {
							if(series[ii].name === chart.series[jj].name) {
								series[ii].color = chart.series[jj].color;
							}
						}
					}
					var tt = {
						name: series[ii].name,
						color: series[ii].color,
						nearest: nearest,
						units: series[ii].data && series[ii].data[0] ? series[ii].data[0].units : "",
						comment: nearest && nearest.comment ? nearest.comment : undefined,
					};
					tooltipData.data.push(tt);
				}
			}
			yield put(actions.setMouseIn(isIn));

			let rrTooltip = document.getElementById("rss-chart-tooltip");
			let rrBar = document.getElementById("rss-chart-bar");
			let sc = document.getElementById("content-scroll");
			let offsetHighchartsDiv = document.getElementById(id).childNodes[0].childNodes[0].childNodes[0].childNodes;
			let actualOffset = null;
			for(var xx = 0; xx < offsetHighchartsDiv.length; xx++) {
				if(offsetHighchartsDiv[xx].className.animVal === "highcharts-plot-border") {
					actualOffset = offsetHighchartsDiv[xx];
					break;
				}
			}
			
			if(!rrTooltip || !highchartDiv) {return;}

			let left = 0;
			let barLeft = highchartDiv.offsetLeft + e.offsetX - 1;
			if(highchartDiv.offsetWidth - 350 < highchartDiv.offsetLeft + e.offsetX) {
				left = highchartDiv.offsetLeft + e.offsetX - 350;
			} else {
				left = highchartDiv.offsetLeft + 18 + e.offsetX;
			}

			/*
			var isMenuOpen = yield select(x => x.menu.isOpen);

			if(isMenuOpen) {
				left += 200;
			}
			*/

			rrTooltip.setAttribute("style", "top: " + (e.pageY) + "px; left: " + left + "px;");
			rrTooltip.setAttribute("class", "pst-tooltip");

			rrBar.setAttribute("style", "top: " + ((highchartDiv.offsetTop) - sc.scrollTop + (Number(actualOffset.getAttribute("y")))) + "px; left: " + barLeft + "px; height: " + Number(actualOffset.getAttribute("height")) + "px;");
			rrBar.setAttribute("class", "pst-bar");

			yield put(actions.setTooltipData(tooltipData));
		});
	},
};

////////
//actions
export const actions = {
	setTooltipData(payload) {
		return {
			type: types.SET_TOOLTIP_DATA,
			payload
		}
	},
	mouseMovedInContainer(e, x, isIn, now, id) {
		return {
			type: types.MOUSE_MOVED_IN_CONTAINER,
			payload: {e, x, isIn, now, id}
		}
	},
	unmount() {
		return {
			type: types.UNMOUNT,
		}
	},
	setMoveData(payload) {
		return {
			type: types.SET_MOVE_DATA,
			payload
		}
	},
	addSeries(id, series) {
		return {
			type: types.ADD_SERIES,
			payload: {id, series}
		}
	},
	chartMouseMove(payload) {
		return {
			type: types.CHART_MOUSE_MOVE,
			payload
		}
	},
	setMouseIn(payload) {
		return {
			type: types.SET_MOUSE_IN,
			payload
		}
	},
	remove(payload) {
		return {
			type: types.REMOVE,
			payload
		}
	},
	override() {
		return {
			type: types.OVERRIDE
		}
	}
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ChartTooltip/redux.js